import React, {useEffect, useState} from 'react';
import {enviarPostulacion} from '../../redux/empleo';
import {useDispatch, useSelector} from 'react-redux';
import LoadingSpinner from '../admin/loading-spinner';
import Nav from "./nav";
import Header from "./header_normal";
import {useHistory, useParams} from "react-router-dom";

const Form = () => {
    let history = useHistory();
    const dispatch = useDispatch();
    const {id} = useParams();

    const [isLoading, setIsLoading] = useState(false);
    const [send, setSend] = useState(parseInt(0));

    const enviar_postulacion = useSelector((store) => store.oft.enviar_postulacion);

    const [data, setData] = useState({
        nombre: '',
        apellido: '',
        telefono: '',
        correo: '',
        likedin: '',
        empleados_relacionados: false,
        terminos_condiciones: false,
        parentezco: '',
        id_empleo: id
    })

    const [file, setFile] = useState(null);

    useEffect(() => {
        if (enviar_postulacion === 200 || enviar_postulacion === 201) {
            setIsLoading(false);
            setSend(enviar_postulacion);
        } else if (enviar_postulacion.status !== 0) {
            setIsLoading(false);
            setSend(enviar_postulacion);
        }
    }, [enviar_postulacion, id]);

    const enviar_Postulacion = (e) => {
        e.preventDefault();
        setIsLoading(true);
        const {nombre, apellido, telefono, correo, terminos_condiciones} = data;
        if (nombre === '' || apellido === '' || telefono === '' || correo === '') {
            alert('Por favor llena todos los campos');
        } else {
            if (terminos_condiciones === false) {
                alert('Debe aceptar los términos y condiciones');
                setIsLoading(false);
            } else {
                if (file) {
                    dispatch(enviarPostulacion(data, file));
                } else {
                    alert('Por favor llena todos los campos');
                    setIsLoading(false);
                }
            }
        }
    }

    const handleFile = (e) => {
        setFile(e.target.files[0]);
    }

    const onInputChange = e => {
        if (e.target.name === 'empleados_relacionados' || e.target.name === 'terminos_condiciones') {
            setData({...data, [e.target.name]: e.target.checked});
        } else {
            setData({...data, [e.target.name]: e.target.value});
        }
    };

    return (
        <>
            <Nav/>
            <Header/>
            <section id="works" className="works-area" style={{marginTop: '20px'}}>
                <div className="container">
                    <div className="card mt-2">
                        {send === 0 ?
                            <form onSubmit={(e) => enviar_Postulacion(e)}>
                                <div className="card-header ml-3">
                                    <h3>Ingresa tus datos para postularte</h3>
                                </div>
                                <div className="card-body">
                                    {isLoading && <LoadingSpinner/>}
                                    <div className="row" style={{padding: '10px 20px'}}>
                                        <div className="col-12 col-md-12 col-lg-6">
                                            <div className="form-group">
                                                <label>Nombres</label>
                                                <input type="text" className="form-control" name="nombre"
                                                       onChange={e => onInputChange(e)}
                                                       tabIndex="1" required/>
                                                <div className="invalid-feedback">
                                                    Ingresa tus nombres
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-12 col-lg-6">
                                            <div className="form-group">
                                                <label>Apellidos</label>
                                                <input type="text" className="form-control" name="apellido"
                                                       onChange={e => onInputChange(e)}
                                                       tabIndex="2" required/>
                                                <div className="invalid-feedback">
                                                    Ingresa tus apellidos
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-12 col-lg-6">
                                            <div className="form-group">
                                                <label>Teléfono</label>
                                                <input type="text" className="form-control" name="telefono"
                                                       onChange={e => onInputChange(e)}
                                                       tabIndex="3" required/>
                                                <div className="invalid-feedback">
                                                    Ingresa tu telefono
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-12 col-lg-6">
                                            <div className="form-group mb-0">
                                                <label>Correo</label>
                                                <input type="email" className="form-control" name="correo"
                                                       onChange={e => onInputChange(e)}
                                                       tabIndex="4" required/>
                                                <div className="invalid-feedback">
                                                    Ingresa tu correo
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-12 col-lg-12">
                                            <div className="form-group mb-0">
                                                <label>Linkeind (opcional)</label>
                                                <input type="text" className="form-control" name="likedin"
                                                       onChange={e => onInputChange(e)}
                                                       tabIndex="5"/>

                                            </div>
                                            <div className="form-group mt-3 ml-4">
                                                <input type="checkbox" className="form-check-input"
                                                       name="empleados_relacionados"
                                                       onChange={e => onInputChange(e)} tabIndex="6"/>
                                                <label className="form-check-label">¿Tiene familiares o amigos que actualmente trabajen en la empresa?</label>

                                            </div>
                                            {
                                                data.empleados_relacionados ? (
                                                    <div className="form-group mb-0">
                                                        <label>Parentesco (opcional)</label>
                                                        <input type="text" className="form-control" name="parentezco"
                                                               onChange={e => onInputChange(e)} tabIndex="7"/>

                                                    </div>
                                                ) : (null)
                                            }
                                            <div className="form-group">
                                                <label htmlFor="customFile">Hoja de vida</label>
                                                <input id="customFile" type="file" className="form-control"
                                                       name="hoja_vida"
                                                       accept=".pdf" onChange={e => handleFile(e)}
                                                       tabIndex="8"
                                                       required/>
                                                <small style={{background: '#daeaf9', padding: 3}}>Por favor, subir únicamente su hoja de vida en PDF. Otros documentos no serán aceptados.</small>
                                            </div>
                                            <div className="form-group mt-3 ml-4">
                                                <input type="checkbox" className="form-check-input"
                                                       name="terminos_condiciones"
                                                       onChange={e => onInputChange(e)} tabIndex="6"/>
                                                <label className="form-check-label">Aceptar cláusula de
                                                    consentimiento</label>
                                                {/*eslint-disable-next-line*/}
                                                <a className="ml-3" href="politicas" target="_blank">Ver</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer text-right">
                                        <button type="submit" className="btn btn-primary" disabled={isLoading}>Enviar
                                            postulación
                                        </button>
                                    </div>
                                </div>
                            </form>
                            :
                            send === 200 || send === 201 ?
                                <div className="card">

                                    <div className="card-body">
                                        <div className="empty-state" data-height="400">
                                            <div className="empty-state-icon bg-success">
                                                <i className="fas fa-check-circle"></i>
                                            </div>
                                            <h2>Postulacion enviada correctamente</h2>
                                            <p className="lead">
                                                Nos comunicaremos con usted en breve
                                            </p>
                                            <button className="mt-4 bb" onClick={() => {
                                                setSend(0);
                                                history.push("/");
                                                window.location.reload();
                                            }}>Volver
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card">
                                    <div className="card-body">
                                        <div className="empty-state" data-height="400">
                                            <div className="empty-state-icon bg-danger">
                                                <i className="fas fa-times"></i>
                                            </div>
                                            <h2>Ocurrio un error</h2>
                                            <p className="lead">
                                                No se pudo procesar tu solicitud
                                            </p>
                                            <button className="mt-4 bb" onClick={() => {
                                                setSend(0);
                                                history.push("/");
                                                window.location.reload();
                                            }}>Volver
                                            </button>
                                        </div>
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </section>
        </>
    )
}
export default Form;